import { medicationsClassificationActions } from '../actions'
import ValidateFormObject from '../utils/ValidateFormObject'
const {
  FETCH_MEDICATION_CLASSIFICATION,
  FETCHING_MEDICATION_CLASSIFICATION,
  FETCH_MEDICATION_CLASSIFICATION_ERROR,
  FETCH_MEDICATIONS_CLASSIFICATION,
  FETCHING_MEDICATIONS_CLASSIFICATION,
  FETCH_MEDICATIONS_CLASSIFICATION_ERROR,
  OPEN_MODAL,
  CLOSE_MODAL,
  CHANGE_MEDICATION_CLASSIFICATION,
  DELETE_MEDICATION_CLASSIFICATION,
  ADD_MEDICATION_CLASSIFICATION,
  EDIT_MEDICATION_CLASSIFICATION,
  FORM_TOUCHED,
  NEW_FORM_MEDICATION_CLASSIFICATION,
  CHANGE_PAGE,
  CHANGE_PER_PAGE,
  CHANGE_ORDER_COLUMN,
  CHANGE_ORDER_DIRECTION,
  MEDICATION_CLASSIFICATION_FORM_ERROR,
  RESET_STATE
} = medicationsClassificationActions
const initialState = {
  loadingMedicationClassification: false,
  loadingMedicationsClassification: false,
  fetchMedicationClassificationError: false,
  fetchMedicationsClassificationError: false,
  medicationsClassification: [],
  order: {
    column: 'nome',
    direction: 1
  },
  medicationClassification: {
    nome: ''
  },
  medicationsClassificationPagination: {
    page: 0,
    rowsPerPage: 50,
    length: 0
  },
  medicationClassificationFormErrors: {},
  medicationClassificationFormTouched: false,
  modalOpen: false
}
const medicationClassificationSchema = {
  add: {
    nome: {
      required: true,
      minValue: 3
    }
  },
  edit: {
    nome: {
      required: true,
      minValue: 3
    }
  }
}
const MedicationClassificationValidate = new ValidateFormObject(medicationClassificationSchema)
const medicationsClassification = (state = initialState, action = {}) => {
  let formSchemaType
  switch (action.type) {
    case CHANGE_MEDICATION_CLASSIFICATION:
      formSchemaType = action.medicationClassification._id ? 'edit' : 'add'
      return {
        ...state,
        medicationClassification: action.medicationClassification,
        medicationClassificationFormErrors: MedicationClassificationValidate.validate({
          formObject: action.medicationClassification,
          formSchemaType
        })
      }
    case MEDICATION_CLASSIFICATION_FORM_ERROR:
      const formErrors = {}
      formSchemaType = state.medicationClassification._id ? 'edit' : 'add'
      formErrors[action.field] = { valid: false, errorMessage: action.message }
      return {
        ...state,
        medicationClassificationFormErrors: MedicationClassificationValidate.validate({
          formObject: state.medicationClassification,
          invalidFields: formErrors,
          formSchemaType
        })
      }
    case NEW_FORM_MEDICATION_CLASSIFICATION:
      return {
        ...state,
        medicationClassification: { ...initialState.medicationClassification },
        medicationClassificationFormErrors: MedicationClassificationValidate.validate({}),
        medicationClassificationFormTouched: false
      }
    case FORM_TOUCHED:
      return {
        ...state,
        medicationClassificationFormTouched: true
      }
    case OPEN_MODAL:
      return {
        ...state,
        modalOpen: true
      }
    case CLOSE_MODAL:
      return {
        ...state,
        modalOpen: false
      }
    case FETCH_MEDICATION_CLASSIFICATION:
      formSchemaType = (action.medicationClassification || {})._id ? 'edit' : 'add'
      return {
        ...state,
        medicationClassification: action.medicationsClassification,
        loadingMedicationClassification: false,
        fetchMedicationClassificationError: false,
        medicationClassificationFormTouched: false,
        medicationClassificationFormErrors: MedicationClassificationValidate.validate({
          formObject: action.medicationClassification,
          formSchemaType
        })
      }
    case FETCHING_MEDICATION_CLASSIFICATION:
      return {
        ...state,
        loadingMedicationClassification: true,
        fetchMedicationClassificationError: false
      }
    case DELETE_MEDICATION_CLASSIFICATION:
      return {
        ...state,
        loadingMedicationsClassification: false,
        fetchMedicationClassificationError: false,
        medicationsClassification: state.medicationsClassification.map(medicationClassification => {
          if (medicationClassification._id === (action.medicationClassification || {})._id) {
            return action.medicationClassification
          }
          return medicationClassification
        })
      }
    case FETCH_MEDICATION_CLASSIFICATION_ERROR:
      return {
        ...state,
        loadingMedicationsClassification: false,
        medicationClassification: { ...initialState.medicationClassification },
        fetchMedicationClassificationError: action.error
      }
    case CHANGE_ORDER_COLUMN:
      return {
        ...state,
        order: {
          direction: 1,
          column: action.column
        }
      }
    case CHANGE_ORDER_DIRECTION:
      return {
        ...state,
        order: {
          ...state.order,
          direction: action.direction
        }
      }
    case CHANGE_PAGE:
      return {
        ...state,
        medicationsClassificationPagination: {
          ...state.medicationsClassificationPagination,
          page: action.page
        }
      }
    case CHANGE_PER_PAGE:
      return {
        ...state,
        medicationsClassificationPagination: {
          ...state.medicationsClassificationPagination,
          rowsPerPage: action.perPage
        }
      }
    case FETCH_MEDICATIONS_CLASSIFICATION:
      return {
        ...state,
        loadingMedicationsClassification: false,
        medicationsClassification: action.medicationsClassification,
        fetchMedicationsClassificationError: false,
        order: action.order,
        medicationsClassificationPagination: {
          length: action.length,
          page: action.page,
          rowsPerPage: action.rowsPerPage
        }
      }
    case EDIT_MEDICATION_CLASSIFICATION:
      return {
        ...state,
        medicationsClassification: state.medicationsClassification.map(medicationClassification => {
          if (medicationClassification._id === action.medicationClassification._id) {
            return action.medicationClassification
          }
          return medicationClassification
        }),
        loadingMedicationsClassification: false,
        fetchMedicationClassificationError: false,
        loadingMedicationClassification: false,
        fetchMedicationsClassificationError: false
      }
    case FETCHING_MEDICATIONS_CLASSIFICATION:
      return {
        ...state,
        loadingMedicationsClassification: true,
        fetchMedicationsClassificationError: false
      }
    case FETCH_MEDICATIONS_CLASSIFICATION_ERROR:
      return {
        ...state,
        loadingMedicationsClassification: false,
        fetchMedicationsClassificationError: action.error,
        loadingMedicationClassification: false
      }
    case ADD_MEDICATION_CLASSIFICATION:
      return {
        ...state,
        loadingMedicationsClassification: false,
        fetchMedicationsClassificationError: false,
        loadingMedicationClassification: false,
        medicationsClassification: [
          ...state.medicationsClassification,
          action.medicationClassification
        ]
      }
    case RESET_STATE:
      return initialState
    default:
      return state
  }
}
export default medicationsClassification



// WEBPACK FOOTER //
// ./src/reducers/medicationClassification.js